/**
 * Creates a object for every .common-form-File DOM element.
 */
common.View.create('crud::form.inputs.ItemSelector', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initInputChecked();
    },

    initInputChecked() {
        const classes = {
            'backgroundChecker': 'bg-indigo-50 border-indigo-200 z-10',
            'labelUnchecked': 'text-gray-900',
            'labelChecked': 'text-indigo-900',
            'instructionUnchecked': 'text-gray-500',
            'instructionChecked': 'text-indigo-700',
        }

        $('input', this.element).change((event) => {
            if ($(event.currentTarget).prop('checked')) {
                this.element.find('.item').removeClass(classes.backgroundChecker)
                    .find('.label').addClass(classes.labelUnchecked).removeClass(classes.labelChecked).end()
                    .find('.instruction').addClass(classes.instructionUnchecked).removeClass(classes.instructionChecked);

                $(event.currentTarget).parents('.item').addClass(classes.backgroundChecker)
                    .find('.label').addClass(classes.labelChecked).end()
                    .find('.instruction').addClass(classes.instructionChecked);
            }
        }).trigger('change');
    },
});
